module.exports = __webpack_public_path__ + "img/439b71a.jpg";